import { Route, Routes } from "react-router-dom";
import "./main.css";
import Login from "./Pages/Login";
import Register from "./Pages/Register";
import Forgot from "./Pages/Forgot";
import Notfound from "./Pages/404";
import Home from "./Pages/Home";
import ChangePassword from "./Pages/Change"
import PrivateRoutes from "./PrivateRoute";
import Dashboard from "./Pages/components/dashboard";
import DashboardBattery from "./Pages/components/dashboardB";
import { Fragment } from "react";
import { MyContextProvider } from "./context";
import ClientDashboard from "./Pages/components/ClientDashboard";
import ClientPlant from "./Pages/components/ClientPlant"
import { useState, useEffect } from 'react';
import supabase from "./Supa";
import Profile from "./Pages/Profile";
import  RegisterTicket from "./Pages/RegisterTicket"
import TicketDashboard from "./Pages/components/TicketDashboard"



function App() {
  const [users, setUsers] = useState([]);
  const [TicketBoolean, setTicketBoolean] = useState("")
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(false)

  //Set Session Token Triggered by Login And Register Page
  if(token){
    sessionStorage.setItem('token',JSON.stringify(token))
    sessionStorage.setItem('id', token.user.id)
    //console.log(token.user.id)
  }

  useEffect(() => {

    getUser()

    // Check Session Token
    if(sessionStorage.getItem('token')){
      let data = JSON.parse(sessionStorage.getItem('token'))
      setToken(data)
    }

    // Password Reset

    supabase.auth.onAuthStateChange(async (event, session) => {
      if (event == "PASSWORD_RECOVERY") {
        const newPassword = prompt("What would you like your new password to be?");
        const { data, error } = await supabase.auth
          .updateUser({ password: newPassword })
 
        if (data) alert("Password updated successfully!")
        if (error) alert("There was an error updating your password.")
      }
    })

    
  }, [])


  async function getUser(){
    try{


        const { data: { user } } = await supabase.auth.getUser()
        if(user != null){

        setUsers(user)
        setTicketBoolean(user.user_metadata.Ticket)
        //updateuserId(user.id)
        //setLoading(false)
        const ticket = user.user_metadata.Ticket
        const id = user.id



        if(ticket === "yes"){
          return "ticket"
        }

        
        console.log(user.user_metadata.Ticket)
       
        }else{
            
           // setUsers({user_metadata:{Ticket:"null"}})
        console.log("App: Get User false")
            
        }

    }catch(e){
        console.log(e.message)
    }
}
  
  return (
    <div className="App">
      <div className="container-fluid">
        <MyContextProvider>
          <Routes>
            <Route element={<PrivateRoutes />}>
              
              {/* Battery */}
              <Route path="/dashboard" element={<ClientDashboard />} />
              <Route path="/home" element={<Home />} />

              {/* Ticket */}
              <Route path="/dash" element={<TicketDashboard />} />

              <Route path="/profile" element={<Profile />} />
              <Route path="*" element={<Notfound />} />

              {/* 
              <Route path="/dashboard_c" element={<ClientDashboard />} />
              <Route path="/dashboard!2" element={<DashboardBattery />} />
              <Route path="/welcome" element={<DashboardBattery />} />
              */}
              
            </Route>
            

            <Route path="/registration" element={<Register setToken={setToken} />} />
            <Route path="/registration_ticket" element={<RegisterTicket setToken={setToken} />} />
            <Route path="/" element={<Login setToken={setToken} />} />
            <Route path="/reset" element={<Forgot />} />
            <Route path="/passwordreset" element={<ChangePassword />} />



          </Routes>
        </MyContextProvider>
      </div>
    </div>
  );
}

export default App;
